import styles from "./index.module.css";
import React, {useEffect} from "react";
import {useCalendarEventsStore} from "../../../store/CalendarEventsStore";

export const EventItem = ({event}) => {
    return (
        <>
            <div className={styles.event}>
                <p className={styles.event_name}>{event.title}</p>
            </div>
        </>
    );
}